import React from 'react';
import ReactDOM from 'react-dom';

import Select, { components } from 'react-select';

/*
const Option = props => {
  const { data, getStyles, innerRef, innerProps, label } = props;
    return (
      <div {...innerProps} css={styles} ref={innerRef}>{label}</div>
    );
};
*/

class MultiSelectCheck extends React.Component {
  constructor (props){
    super(props)
    this.options = this.props.options
    let values = this.props.value
    let defaultValue = []

    // set multiple default value
    if(values != undefined) {
      values = values.split(',')
      for(let i=0; i<values.length; i++) {
        for(let j=0; j < this.options.length; j++) {
          if(values[i] == this.options[j].value) {
            defaultValue.push(this.options[j])
          }
        }
      }
    }

    // select first option
    this.state = {'selected': defaultValue}
    this.onChange = this.onChange.bind(this)
    // this.findValue = this.findValue.bind(this)
  }

  onChange(value) {
    this.setState({
      value: value,
    });

    if(this.props.onChange != undefined){
      this.props.onChange();  
    }    
  }
  
  render() {
    return (
        <Select 
          name={this.props.name} 
          options={this.options} 
          defaultValue={this.state.selected} 
          onChange={this.onChange} 
          isSearchable={false} 
          isClearable={false} 
          isMulti />
    );
  }
}

export default MultiSelectCheck

// module.exports = Option